import atMentionsPluginTrigger from './utils/atMentionsPluginTrigger';
import createLazyPlugin from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "AtMentionsPlugin" */ './plugin/AtMentionsPlugin');
});
export var LazyAtMentionsPluginClass = createLazyPlugin(lazyModule, function (m) { return m.default; }, 'AtMention', atMentionsPluginTrigger);
//# sourceMappingURL=index.js.map